import { aardcodes, looncodes } from '@/helpers/constants';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/platform/ui';

const contents = {
    income_relationship_type: {
        ...looncodes,
    },
    nature_of_employment: {
        ...aardcodes,
    },
};

const DataTypes = ({ data, type }) => (
    <ul className='space-x-2'>
        {data?.map(value => (
            <Tooltip key={value}>
                <TooltipTrigger>
                    <li>{value}</li>
                </TooltipTrigger>
                <TooltipContent>{contents[type][value] || ''}</TooltipContent>
            </Tooltip>
        ))}
    </ul>
);

export default DataTypes;
